module.exports = __webpack_public_path__ + "static/media/Caixa6.fda7aa9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/RelCaixa/Caixa6.png
// module id = 2036
// module chunks = 0